import SpriteSymbol from "../../../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "platform",
  "use": "platform-usage",
  "viewBox": "0 0 32 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 28\" id=\"platform\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M16 0L0 8l16 8 16-8zM4 7.8L16 2l12 5.8L16 14zM27.5 14L16 20 4.5 14H0l16 8 16-8zm0 6L16 26 4.5 20H0l16 8 16-8z\" data-name=\"Page-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol